import {useEffect,useMemo,useState} from 'react';
import {LANGUAGES,LanguageContext,useLanguage} from './LanguageContext.js';
import './language.css';

const valid=value=>LANGUAGES.some(item=>item.id===value);
function initialLanguage(){
  const query=new URLSearchParams(window.location.search).get('lang');
  if(valid(query))return query;
  try {const saved=localStorage.getItem('minimural-locale');return valid(saved)?saved:'en';}catch{return 'en';}
}
export function LanguageProvider({children}){
  const [language,setState]=useState(initialLanguage);
  const setLanguage=value=>{if(valid(value))setState(value);};
  useEffect(()=>{
    document.documentElement.lang=LANGUAGES.find(item=>item.id===language).html;
    try{localStorage.setItem('minimural-locale',language);}catch{}
    const url=new URL(window.location.href);
    if(url.searchParams.has('lang')){url.searchParams.set('lang',language);history.replaceState(history.state,'',url.pathname+url.search+url.hash);}
  },[language]);
  const value=useMemo(()=>({language,setLanguage}),[language]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}
export function LanguageSelect({studio=false}){
  const {language,setLanguage}=useLanguage();
  return <label className={'site-language'+(studio?' studio-language':'')}>
    <span className="sf-visually-hidden">Language</span>
    <select className="sf-locale-select" aria-label="Language" value={language} onChange={event=>setLanguage(event.target.value)} translate="no">
      {LANGUAGES.map(item=><option key={item.id} value={item.id} translate="no">{item.label}</option>)}
    </select>
  </label>;
}
